export const FORMATTING_PARTS = {
    INTEGER: 'integer',
    DECIMAL: 'decimal',
    FRACTION: 'fraction',
    MINUS_SIGN: 'minusSign',
    LITERAL: 'literal',
    PERCENTAGE: 'percentage',
    CURRENCY: 'currency',
};
